export default function FacilitySideSheetSkeleton() {
  return (
    <div className="pt-7">
      {/* ObjectHeading Skeleton */}
      <div className="flex flex-col gap-6">
        <div data-testid="profile-skeleton" className="space-y-4">
          <div className="flex items-center space-x-4">
            <div className="animate-pulse rounded-full bg-gradient-to-r from-gray-200 to-gray-50 h-12 w-12" />
            <div className="flex-1 space-y-2 py-1">
              <div className="animate-pulse h-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50 w-3/4" />
              <div className="animate-pulse h-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50 w-1/4" />
            </div>
          </div>
        </div>

        {/* View Facility Button */}
        <div className="animate-pulse h-8 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
      </div>

      {/* Details Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <div className="animate-pulse h-6 w-16 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-2">
            <div className="animate-pulse h-4 w-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
            <div className="animate-pulse h-4 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          </div>
          <div className="flex items-center gap-2">
            <div className="animate-pulse h-4 w-4 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
            <div className="animate-pulse h-4 w-48 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          </div>
        </div>
      </div>

      {/* Phone Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <div className="animate-pulse h-6 w-16 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-2">
            <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
            <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          </div>
          <div className="flex items-center gap-2">
            <div className="animate-pulse h-6 w-6 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
            <div className="animate-pulse h-6 w-32 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          </div>
        </div>
      </div>

      {/* Addresses Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <div className="animate-pulse h-6 w-20 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        <div className="space-y-4 w-full">
          <div className="animate-pulse h-6 w-64 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-64 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
          <div className="animate-pulse h-6 w-24 rounded-full bg-gradient-to-r from-gray-200 to-gray-50" />
        </div>
      </div>
    </div>
  );
}
